<template>
  <div>
    <div class="d-flex flex-column">
      <div class="section">
        <div class="monthlyHoroscope">
          <div class="heroElmWrap">
            <img
              class="horo_image"
              :src="horoscopeData.horoscopeMonth.image"
              :alt="horoscopeData.horosign"
            />
            <img
              class="sumdge"
              src="../../assets/mobiscope/imgs/smudge_overlay.png"
            />
          </div>

          <div class="container">
            <div class="monthlyHoroscope__content" v-if="horoscopeData.horosign != ''">
              <h1 class="std__title">{{ horoscopeData.horosign }}</h1>
              <h2 class="std__subtile">
                {{$t("zodiac_of_the_month")}}
              </h2>
              <p class="horoscope">
                <span>{{ horoscopeData.horoscopeMonth.horoscope_description.today[`${language}`] }}</span>
                <!-- <span v-if="language !== 'english'">{{horoscopeData.descTranslate}}</span> -->
              </p>
              <button class="btn btn-lg stdBtn">
                <router-link class="" style="text-decoration:none;" v-if="auth_mobis === 'loggedin'"
                  :to="{
                    name: 'HoroscopeDetails',
                    params: { sign: horoscopeData.horosign }
                  }">{{$t("read_more")}}</router-link>
                  <span @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("read_more") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="section__content center">
            <h2 class="std__subtile">{{ $t("horoscopes") }}</h2>
            <div class="row">
              <div
                class="col-md-2 col-sm-4 col-4"
                v-for="sunsign in horoscopeData.data"
                :key="sunsign.key"
              >
                <router-link class="signIcon" :to="{ name: 'HoroscopeDetails', params: { sign: sunsign.name }}" v-if="auth_mobis === 'loggedin'">
                  <span class="signIcon__img" :style="{ '-webkit-mask': `url(${sunsign.icon})` }"></span>
                  <span class="shadow"></span>
                  <div class="signIcon__label">{{ sunsign.name }}</div>
                  <div class="signIcon__date">{{ sunsign.date }}</div>
                </router-link>
                <a class="signIcon" @click="guest_mobis()" v-if="auth_mobis === 'guest'">
                  <span class="signIcon__img" :style="{ '-webkit-mask': `url(${sunsign.icon})` }"></span>
                  <span class="shadow"></span>
                  <div class="signIcon__label">{{ sunsign.name }}</div>
                  <div class="signIcon__date">{{ sunsign.date }}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapActions } from "vuex";

export default {
  data() {
    return {
    };
  },
  computed: mapGetters(["language", "auth_mobis"]),
  props: ["horoscopeData", "loadingPage"],
  methods:{
    ...mapActions(["guest_mobis"]),
  }
  
};

</script>

<style lang="scss" scoped>
li :hover {
  color: black;
}

.zodiac_month {
  font-weight: 500;
  color: white;
}

.horoscope {
  font-size: 1.2rem;
  text-align: justify;
}

.horo_btn {
  margin: 10px;
  font-size: 10pt;
  width: 160px;
}

.month_wrap,
.horo_wrap {
  height: 100%;
  margin-bottom: 20px;
}

.horo_img {
  width: 100%;
}
@media (max-width: 991px) {
}
</style>



// WEBPACK FOOTER //
// src/components/mobiscope/Horoscope.vue